<template>
  <v-card color="rgba(255,0,0,0)">
    <div class="embed-container embed-containervideo">
      <youtube
        class="embed-container2"
        :video-id="videoId"
        player-width="1080"
        player-height="720"
        @playing="playing"
        @ended="ended"
        @paused="paused"
        :player-vars="{ autoplay: 1 }"
      ></youtube>
    </div>
  </v-card>
</template>
<script>
import urlComp from "@/components/change_url";
import { db } from "@/main";
import navBar from "@/components/navbar";
import foot from "@/components/footer";
import { getIdFromURL, getTimeFromURL } from "vue-youtube-embed";
export default {
  components: { navBar, foot, urlComp },
  props: {
    videoId: String,
  },
  data() {
    return {
      parts: [],
      videos_array: [],
      videoPart: "",
      flag_onlyOne: false,
      enableVideo: false,
    };
  },
  methods: {
    videoChange() {
      let h = this.parts.indexOf(this.videoPart);
      this.videoId = this.videos_array[h];
    },
    ready(event) {
      this.player = event.target;
    },
    playing(event) {
      console.log("Reproduciendo...");
    },
    paused(event) {
      console.log("pausado...");
    },
    ended(event) {
      console.log("terminado...");
    },
    change() {
      // when you change the value, the player will also change.
      // If you would like to change `playerVars`, please change it before you change `videoId`.
      // If `playerVars.autoplay` is 1, `loadVideoById` will be called.
      // If `playerVars.autoplay` is 0, `cueVideoById` will be called.
      this.videoId = "another video id";
    },
    stop() {
      this.player.stopVideo();
    },
    pause() {
      this.player.pauseVideo();
    },
  },
  created: async function () {
   
      //console.log("me llego", this.videoId);
      let videoIdd = getIdFromURL(this.videoId);
      
      this.videoId = videoIdd;
  
  },
};
</script>
<style scoped>
#backGND {
  background-image: url("../../assets/back.png");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  margin-top: auto;
}
.embed-container {
  position: relative !important;
  padding-bottom: 60.25% !important;
  height: 0 !important;
  overflow: hidden !important;
}
.embed-container2 {
  position: absolute !important;
  top: 0 !important;
  left: 0 !important;
  width: 100% !important;
  height: 100% !important;
}
.embed-containervideo {
  position: relative !important;
  padding-bottom: 60.22% !important;
  height: 0 !important;
  overflow: hidden !important;
}
#triangle {
  height: 10rem;
  background: linear-gradient(
    to top left,
    rgba(255, 0, 0, 0) 0%,
    rgba(255, 0, 0, 0) 50%,
    #000000 50%,
    #000000 100%
  );
}
.rotate {
  transform: rotate(-5deg);
}
#triangle_down {
  height: 10rem;

  background: linear-gradient(
    to top right,
    rgba(255, 0, 0, 0) 0%,
    rgba(255, 0, 0, 0) 50%,
    rgba(200, 200, 200, 1) 50%,
    rgba(200, 200, 200, 1) 100%
  );
}

#title {
  font-size: 50px;
  font-family: "Times, Times New Roman, serif";
  color: white;
  text-shadow: 0px 0px 30px #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/components/stream_video_components/player.vue